"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButton = exports.StyledText = exports.ErrorMessageContainer = exports.StyledCard = exports.ErrorsBody = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var storm_ui_1 = require("@amzn/storm-ui");
exports.ErrorsBody = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  padding: ", ";\n  width: 100%;\n"], ["\n  background-color: ", ";\n  padding: ", ";\n  width: 100%;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.concrete;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.xxlarge;
});
exports.StyledCard = (0, styled_components_1.default)(storm_ui_1.Card)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-inline-start: auto;\n  margin-inline-end: auto;\n  margin-top: ", ";\n  text-align: center;\n  max-width: 50vw;\n"], ["\n  margin-inline-start: auto;\n  margin-inline-end: auto;\n  margin-top: ", ";\n  text-align: center;\n  max-width: 50vw;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.xxlarge;
});
exports.ErrorMessageContainer = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-top: ", ";\n  margin-inline-start: auto;\n  margin-inline-end: auto;\n  max-width: 350px;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n"], ["\n  margin-top: ", ";\n  margin-inline-start: auto;\n  margin-inline-end: auto;\n  max-width: 350px;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.medium;
});
exports.StyledText = (0, styled_components_1.default)(storm_ui_1.Text)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  max-width: 600px;\n"], ["\n  max-width: 600px;\n"])));
exports.StyledButton = (0, styled_components_1.default)(storm_ui_1.Button)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-top: ", ";\n  margin-bottom: ", ";\n  :hover {\n    color: ", " !important;\n  }\n"], ["\n  margin-top: ", ";\n  margin-bottom: ", ";\n  :hover {\n    color: ", " !important;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.xlarge;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.small;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.black;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
